// students/detail
import React, { useCallback, useState, useMemo } from 'react';
import View from 'src/pages/students/detail';
import AppRender from 'src/routes/app-render';
import { useForm } from 'src/hooks/use-form';
import { studentApi } from 'src/api/students/vm-view';

const Page = () => {
  const { handleNavigate, itemNavigate } = useForm();
  const { toPage, student } = useMemo(() => {
    const studentInfo = {
      id: itemNavigate?.id,
      code: itemNavigate?.code,
      name: itemNavigate?.name,
      phone: itemNavigate?.phone
    };
    return {
      toPage: itemNavigate?.to,
      student: studentInfo
    }
  }, [itemNavigate]);

  const [data, setData] = useState(null);
  const fetchData = useCallback(async () => {
    if (!itemNavigate) return;
    
    return studentApi.getDetail(itemNavigate, setData);

    // if(itemNavigate){
    //   const toPage = itemNavigate.to;
    //   console.log('=========================>>>>', toPage);

    //   if(toPage === 'tracking'){
    //     studentApi.getTracking(
    //       itemNavigate,
    //       (result) => {
    //         setData(result);
    //       },
    //     );
    //   }else if(toPage === 'course'){

    //   }else{
    //     studentApi.getDetail(
    //       itemNavigate,
    //       (result) => {
    //         setData(result);
    //       },
    //     );
    //   }
    // }
  }, [itemNavigate]);

  return (
    <AppRender apiCall={fetchData}>
      {data && <View onNavigate={handleNavigate} item={data} toPage={toPage} student={student} />}
    </AppRender>
  );
};

export default Page;
